export enum StorageValues {
  AccountsKey = 'Accounts',
  QuoteKey = 'Quotes',
  OrderKey = 'Orders',
  InvoiceKey = 'Invoices',
  LnOrderKey = 'Ln-orders',
  CachedFilters = 'cachedValues',
  CachedSort = 'sort',
  LeadsKey = 'Leads',
  LeadsHistoryKey = 'LeadsHistory',
  LastTenQuotesKey = 'LastTenQuotesKey',
  ProjectsKey = 'Projects',
  ProjectsHistoryKey = 'ProjectsHistory',
  SelectedAMId = 'selectedAccountManagerId',
  SelectedAMName = 'selectedAccountManagerName',
  SelectedAMOwnerId = 'selectedAccountManagerOwnerId'
}
